import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_CHANNEL_INSTANCES = createAsyncActionTypes('FETCH_CHANNEL_INSTANCES');
export const FETCH_CHANNEL_INSTANCE_BY_ID = createAsyncActionTypes('FETCH_CHANNEL_INSTANCE_BY_ID');